import React, { createContext, useContext, useEffect, useState } from 'react';

type ThemeMode = 'light' | 'dark';
type ThemePreset = 'prestige' | 'tech' | 'growth' | 'creative' | 'focus' | 'zen';

interface ThemeContextType {
  mode: ThemeMode;
  preset: ThemePreset;
  toggleMode: () => void;
  setPreset: (preset: ThemePreset) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [mode, setMode] = useState<ThemeMode>('dark');
  const [preset, setPreset] = useState<ThemePreset>('prestige');

  useEffect(() => {
    const root = window.document.documentElement;
    
    // Handle Mode
    if (mode === 'light') {
      root.classList.add('light');
    } else {
      root.classList.remove('light');
    }

    // Handle Preset
    root.setAttribute('data-theme', preset);
    
  }, [mode, preset]);

  const toggleMode = () => {
    setMode(prev => prev === 'dark' ? 'light' : 'dark');
  };

  return (
    <ThemeContext.Provider value={{ mode, preset, toggleMode, setPreset }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
